import { inject, Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { UserService } from "./user.service";
import { LoginEndconsumerResponseData } from "../models/user.model";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _apiService: ApiService = inject(ApiService);
  private _userService: UserService = inject(UserService);

  private _accessToken: string | null = null;

  constructor() {
    this._userService.user$.subscribe((userData: any | '') => {
      if (userData && typeof userData === 'object' && 'tokens' in userData) {
        this._accessToken = userData.tokens?.access ?? null;
      } else {
        this._accessToken = null;
      }
    });
  }

  setAccessToken(token: string): void {
    this._accessToken = token;

    const userData = this._userService.get();
    if (userData && userData.tokens) {
      userData.tokens.access = token;
      this._userService.set(userData);
    }
  }

  getAccessToken(): string | null {
    return this._accessToken;
  }

  refreshToken(): Observable<any> {
    const userData: LoginEndconsumerResponseData | '' = this._userService.get();
    const requestData: {refresh: string} = {
      refresh: userData ? userData.tokens.refresh : ''
    }
    return this._apiService.post('/auth/token/refresh/', requestData);
  }

  clearAccessToken(): void {
    this._accessToken = null;
  }
}
